import {Entity} from '@s-ui/domain'

export default class MakeEntity extends Entity {
  /**
   * @param {Object} make
   * @param {String} make.id
   * @param {Boolean} make.isMostSearched
   * @param {String} make.image
   * @param {String} make.name
   * @param {String} make.slug
   * @param {String} make.url
   * */

  getId() {
    return this._id
  }
}
